export default __webpack_public_path__ + "static/media/method3.6d2cc072.png";